export enum PageHub {
  HOW_TO_USE = 'how-to-use',
}
export type PageHubVal = `${PageHub}`;
